import React from 'react';
import { useMetaPixel } from '../hooks/useMetaPixel';
import { HeroSection } from '../components/HeroSection';
import { ProblemSection } from '../components/ProblemSection';
import { FailedMethodsSection } from '../components/FailedMethodsSection';
import { MechanismSection } from '../components/MechanismSection';
import { WhatYouGetSection } from '../components/WhatYouGetSection';
import { WhoIsForSection } from '../components/WhoIsForSection';
import { HowItWorksSection } from '../components/HowItWorksSection';
import { ProofSection } from '../components/ProofSection';
import { FAQSection } from '../components/FAQSection';
import { OfferSection } from '../components/OfferSection';
import { Footer } from '../components/Footer';
export function LandingPage() {
  useMetaPixel();
  return <main className="min-h-screen w-full font-sans bg-white selection:bg-gold/30 selection:text-navy-900" data-id="element-227">
      <HeroSection data-id="element-228" />
      <ProblemSection data-id="element-229" />
      <FailedMethodsSection data-id="element-230" />
      <MechanismSection data-id="element-231" />
      <WhatYouGetSection data-id="element-232" />
      <WhoIsForSection data-id="element-233" />
      <HowItWorksSection data-id="element-234" />
      <ProofSection data-id="element-235" />
      <FAQSection data-id="element-236" />
      <OfferSection data-id="element-237" />
      <Footer data-id="element-238" />
    </main>;
}